import { MdCheck, MdSchedule } from 'react-icons/md';
import { CohortAction } from '../types';

interface ActionStatusBarProps {
  action: CohortAction | null;
  label: string; // e.g. "Onboarding", "Connection", "Feedback", "Check-in", "Consent"
  notScheduledText?: string;
}

const ActionStatusBar = ({ action, label, notScheduledText }: ActionStatusBarProps) => {
  const status = action?.status;
  const isCompleted = status === 'completed';
  const isActive = status === 'active';

  const bgClass = isCompleted
    ? 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-700'
    : isActive
      ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-700'
      : 'bg-gray-50 dark:bg-gray-900/20 border-gray-200 dark:border-gray-700';

  const icon = isCompleted
    ? <MdCheck className="h-5 w-5 flex-shrink-0 mt-0.5 text-blue-600 dark:text-blue-400" />
    : <MdSchedule className={`h-5 w-5 flex-shrink-0 mt-0.5 ${isActive ? 'text-green-600 dark:text-green-400' : 'text-gray-500 dark:text-gray-400'}`} />;

  const title = isCompleted
    ? `${label} Emails Sent`
    : isActive
      ? `${label} Emails Scheduled`
      : 'Schedule Status';

  const renderDescription = () => {
    if (isCompleted) {
      return (
        <>
          {action?.completedAt ? (
            <>
              Emails sent on:{' '}
              <strong>{new Date(action.completedAt).toLocaleString()}</strong>
            </>
          ) : (
            'Emails sent.'
          )}
          {action?.metadata && (
            <span className="ml-2 text-xs text-gray-500">
              ({action.metadata.successfulEmails}/{action.metadata.totalEmails} delivered)
            </span>
          )}
        </>
      );
    }
    if (isActive) {
      return action?.scheduledAt ? (
        <>
          Emails will be sent at:{' '}
          <strong>{new Date(action.scheduledAt).toLocaleString()}</strong>
        </>
      ) : (
        'Emails scheduled.'
      );
    }
    return notScheduledText || 'Not scheduled yet.';
  };

  return (
    <div className={`p-4 rounded-lg border ${bgClass}`}>
      <div className="flex items-start gap-2">
        {icon}
        <div className="flex-1">
          <h4 className="font-semibold text-navy-700 dark:text-white mb-1">{title}</h4>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            {renderDescription()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActionStatusBar;
